import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Container = styled.div`
  padding: 0 16px;
`;

const Title = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;

const ReviewList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ReviewCard = styled.div`
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 16px;
`;

const ReviewerName = styled.p`
  font-weight: bold;
  margin-bottom: 8px;
`;

const ReviewText = styled.p`
  font-style: italic;
`;

const OurPatientsThoughts: React.FC = () => {
  const { t } = useTranslation();
  const reviews = t("OurPatientsThoughts.reviews", { returnObjects: true }) as {
    name: string;
    text: string;
  }[];

  return (
    <Container className="OurPatientsThoughts">
      <Title>{t("OurPatientsThoughts.title").toUpperCase()}</Title>
      <ReviewList>
        {reviews.map((review: any, index: number) => (
          <ReviewCard key={index}>
            <ReviewerName>{review.name}</ReviewerName>
            <ReviewText>"{review.text}"</ReviewText>
          </ReviewCard>
        ))}
      </ReviewList>
    </Container>
  );
};

export default OurPatientsThoughts;
